import React, { useState, useEffect } from 'react';
import { Container, Button, Card, Modal } from 'react-bootstrap';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/useAuthStore';
import apiClient from '../../api';

const PortalLayout = () => {
  const { user, logout, login, token } = useAuthStore();
  const navigate = useNavigate();
  const [profiles, setProfiles] = useState([]);
  const [showSwitchModal, setShowSwitchModal] = useState(false);

  const apiBase = apiClient?.defaults?.baseURL || '';
  const cleanApiBase = apiBase ? (apiBase.endsWith('/') ? apiBase.slice(0, -1) : apiBase) : '';

  useEffect(() => {
    const fetchProfiles = async () => {
      if (!user) return;
      try {
        const res = await apiClient.get('/transport/users/me/profiles');
        setProfiles(res.data || []);
      } catch (err) {
        console.error("Error cargando perfiles de cliente:", err);
      }
    };
    fetchProfiles();
  }, [user]);

  const activeProfile = profiles.find(p => 
    (user?.role === 'passenger' && p.role === 'passenger' && p.profile_id === user?.linked_passenger_id) ||
    (user?.role === 'requester' && p.role === 'requester' && p.profile_id === user?.linked_requester_id)
  );

  const clientName = activeProfile ? activeProfile.client_name : '';
  const clientLogoUrl = activeProfile ? activeProfile.client_logo_url : null;

  const handleSwitchProfile = async (profile) => {
    try {
      const res = await apiClient.post('/transport/users/me/switch-profile', {
        role: profile.role,
        profile_id: profile.profile_id
      });
      // Actualizar usuario en el almacén global
      login(token, res.data);
      // Forzar recarga para reiniciar el flujo y recargar viajes con el nuevo contexto
      window.location.href = '/portal';
    } catch (err) {
      console.error("Error al cambiar de cliente:", err);
      alert("Error al intentar cambiar de cliente. Por favor intente nuevamente.");
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      {/* Banner Persistente de Cliente Activo - Muy notorio y visible en móviles */}
      <div style={{
        backgroundColor: '#6f42c1', // Morado corporativo de Emilia
        color: '#ffffff',
        paddingTop: 'calc(12px + env(safe-area-inset-top, 0px))',
        paddingBottom: '12px',
        paddingLeft: '15px',
        paddingRight: '15px',
        fontSize: '13px',
        fontWeight: 'bold',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1050,
        position: 'relative'
      }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
          🏢 <span style={{ letterSpacing: '0.5px' }}>EMPRESA ACTIVA:</span> 
          <span className="badge bg-white text-dark fs-6 py-1 px-2 fw-bolder" style={{ border: '1px solid #ddd' }}>
            {clientName ? clientName.toUpperCase() : 'CARGANDO...'}
          </span>
          <span className="text-white-50" style={{ fontSize: '11px' }}>
            ({user?.role === 'passenger' ? 'PASAJERO' : 'SOLICITANTE'})
          </span>
        </span>
        {profiles.length > 1 && (
          <Button 
            variant="light" 
            size="sm" 
            className="fw-bold py-0 px-2 shadow-sm"
            style={{ fontSize: '11px', color: '#6f42c1', height: '24px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}
            onClick={() => setShowSwitchModal(true)}
          >
            Cambiar Empresa 🔄
          </Button>
        )}
      </div>

      {/* Navbar Corporativo Nativo */}
      <nav className="navbar navbar-expand navbar-light bg-white shadow-sm mb-4 px-4 py-2">
        <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap gap-2">
          <Link to="/portal" className="navbar-brand fw-bold text-primary d-flex align-items-center">
            <img 
              src="/logoe.png" 
              alt="Transportes Emilia" 
              style={{ height: '52px', objectFit: 'contain' }}
              onError={(e) => { e.target.src = '/EmiGo.png'; }}
            />
          </Link>

          {/* Lado derecho del Navbar siempre visible */}
          <div className="d-flex align-items-center flex-wrap gap-3 ms-auto">
            {/* Links Principales */}
            <div className="d-flex align-items-center gap-2">
              <Link to="/portal/new-trip" className="btn btn-link text-decoration-none text-secondary fw-bold px-2" style={{ fontSize: '14px' }}>
                Solicitar Viaje
              </Link>
              <Link to="/portal/my-trips" className="btn btn-link text-decoration-none text-secondary fw-bold px-2" style={{ fontSize: '14px' }}>
                Mis Viajes
              </Link>
            </div>

            {/* Logo o Nombre de Cliente */}
            {clientLogoUrl && activeProfile?.client_id ? (
              <img 
                key={clientLogoUrl}
                src={`${cleanApiBase}/transport/clients/${activeProfile.client_id}/logo-image`} 
                alt={clientName} 
                style={{ height: '48px', maxWidth: '150px', objectFit: 'contain', borderLeft: '2px solid #ddd', paddingLeft: '15px' }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : clientName ? (
              <span className="text-primary fw-bold d-none d-sm-inline" style={{ fontSize: '14px', borderLeft: '2px solid #ddd', paddingLeft: '15px' }}>
                🏢 {clientName}
              </span>
            ) : null}

            {/* Usuario Activo */}
            <span className="text-muted small d-none d-md-inline" style={{ fontSize: '13px' }}>
              👤 <strong>{user?.name || user?.email}</strong> ({user?.role === 'passenger' ? 'Pasajero' : 'Solicitante'})
            </span>

            {/* Boton Salir */}
            <Button variant="outline-danger" size="sm" onClick={handleLogout} className="fw-bold">
              Salir
            </Button>
          </div>
        </div>
      </nav>

      {/* Contenido Principal */}
      <Container>
        <Outlet />
      </Container>

      {/* Modal Táctil de Selección de Clientes */}
      <Modal 
        show={showSwitchModal} 
        onHide={() => setShowSwitchModal(false)} 
        centered 
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="h5 fw-bold text-dark w-100 text-center">
            🏢 Seleccionar Empresa
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4 py-3">
          <p className="text-muted text-center small mb-3">
            Selecciona el cliente o perfil con el que deseas solicitar viajes ahora.
          </p>
          <div className="d-grid gap-2" style={{ maxHeight: '320px', overflowY: 'auto', paddingRight: '4px' }}>
            {profiles.map((p, idx) => {
              const isCurrent = activeProfile && activeProfile.role === p.role && activeProfile.profile_id === p.profile_id;
              return (
                <Card 
                  key={idx}
                  className={`border-2 shadow-sm ${isCurrent ? 'border-primary bg-primary bg-opacity-10' : 'border-light bg-white'}`}
                  style={{ cursor: 'pointer', transition: 'transform 0.2s', borderRadius: '10px' }}
                  onClick={() => {
                    if (!isCurrent) {
                      handleSwitchProfile(p);
                    } else {
                      setShowSwitchModal(false);
                    }
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
                >
                  <Card.Body className="d-flex justify-content-between align-items-center p-3">
                    <div>
                      <h6 className="mb-0 fw-bold text-dark">{p.client_name}</h6>
                      <span className="badge bg-secondary text-white mt-1" style={{ fontSize: '10px' }}>
                        {p.role === 'passenger' ? 'Pasajero' : 'Solicitante'}
                      </span>
                    </div>
                    {isCurrent ? (
                      <span className="text-primary fw-bold fs-5">✓</span>
                    ) : (
                      <span className="text-muted fs-5">➔</span>
                    )}
                  </Card.Body>
                </Card>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 justify-content-center">
          <Button variant="outline-secondary" size="sm" onClick={() => setShowSwitchModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PortalLayout;
